<script setup lang="ts">
/**
 * qCMS brand mark — the constructed "q" (bowl + descending stem) from the
 * "Indigo a křída" identity. Geometry lives in a 100×100 frame; the stem
 * drops a third of the height below the bowl so the glyph reads as "q"
 * even at 16 px.
 *
 * `tile` renders the app-icon variant: indigo rounded square + white mark.
 */
withDefaults(
  defineProps<{
    size?: number
    color?: string
    tile?: boolean
    tileRadius?: number
  }>(),
  { size: 26, color: 'var(--accent, #2b3a8f)', tile: false, tileRadius: 11 },
)
</script>

<template>
  <span
    v-if="tile"
    class="brand-tile"
    :style="{
      width: size + 'px',
      height: size + 'px',
      borderRadius: tileRadius + 'px',
    }"
  >
    <svg viewBox="0 0 100 100" :width="Math.round(size * 0.62)" :height="Math.round(size * 0.62)" aria-hidden="true">
      <circle cx="45.8" cy="36.5" r="22" fill="none" stroke="#ffffff" stroke-width="13" />
      <rect x="69.8" y="8" width="13" height="84" rx="6.5" fill="#ffffff" />
    </svg>
  </span>
  <svg
    v-else
    viewBox="0 0 100 100"
    :width="size"
    :height="size"
    aria-hidden="true"
    style="display: block; flex: 0 0 auto"
  >
    <circle cx="45.8" cy="36.5" r="22" fill="none" :stroke="color" stroke-width="13" />
    <rect x="69.8" y="8" width="13" height="84" rx="6.5" :fill="color" />
  </svg>
</template>

<style scoped>
.brand-tile {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent, #2b3a8f);
  flex: 0 0 auto;
}
</style>
